import axiosInstance from "./axiosInstance";

const forceCommunityBanService = {
  /**
   * Permanent community ban (same as automated report ban). Admin/Developer only.
   * @param {{ userId?: string, email?: string, reason: string }} payload — exactly one of userId or email
   */
  async forceBan(payload) {
    try {
      const response = await axiosInstance.post("admin/users/force-community-ban", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default forceCommunityBanService;
